import { useGeneralModalsStore } from '@/stores/genenalModals';
import i18n from '@/lang';

export const useConfirm = () => {
  const generalModalsStore = useGeneralModalsStore();
  const { t } = i18n.global;

  const confirm = (options: {
    title?: string;
    text?: string;
    confirmButtonText?: string;
    confirmButtonLoadingText?: string;
    cancelButtonText?: string;
  }) => {
    return new Promise((resolve) => {
      generalModalsStore.showModal({
        title: options.title || t('general.button.confirm'),
        text: options.text || '',
        rightButtonText: options.confirmButtonText || t('general.button.confirm'),
        rightButtonLoadingText: options.confirmButtonLoadingText || t('general.button.processing'),
        leftButtonText: options.cancelButtonText || t('general.button.cancel'),
        rightButtonCallback: () => {
          resolve(true);
          return true;
        },
        leftButtonCallback: () => {
          resolve(false);
          return true;
        },
      });
    });
  };

  return {
    $confirm: {
      confirm,
    },
  };
};
